import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teacher-data',
  templateUrl: './teacher-data.component.html',
  styleUrls: ['./teacher-data.component.scss']
})
export class TeacherDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
